module.exports = __webpack_public_path__ + "static/render1-4147e340cd30823e5ad3d43e2dd76bf7.png";